<template>
  <div class="relative cursor-grab">
    <ion-scroll
      overflow-scroll="false"
      direction="x"
      :id="computedID"
      :class="[
        height || '',
        classes || '',
        'flex w-full max-w-full overflow-x-auto overflow-y-visible carousel',
      ]"
      ref="ionScroll"
    >
      <slot></slot>
    </ion-scroll>
  </div>
</template>

<script>
import { IonScroll } from "@ionic/vue";

export default {
  components: { IonScroll },

  props: {
    height: [Number, String],
    classes: [String, Array],
    id: String,
  },

  methods: {
    scrollToElement(index, selectors, smooth = true) {
      const scrollEl = this.getScrollContainer();
      if (!scrollEl) return Promise.resolve(false);

      const children = this.getChildren(scrollEl, selectors);
      const target = this.getTarget(children, index);
      if (!target) return Promise.resolve(false);

      return this.performScroll(target, smooth);
    },

    getScrollContainer() {
      const el =
        this.$refs.ionScroll?.$el || document.getElementById(this.computedID);
      if (!el) console.warn("Elemento scroll non trovato");
      return el;
    },

    getChildren(scrollEl, selectors) {
      if (selectors) {
        const nodes = scrollEl.querySelectorAll(selectors);
        if (nodes.length) return Array.from(nodes);
      }
      return Array.from(scrollEl.children);
    },

    getTarget(children, index) {
      const el = children[index];
      if (!el) console.warn("Target elemento non valido");
      return el;
    },

    performScroll(targetEl, smooth) {
      const DELAY = 500;
      targetEl.scrollIntoView({
        behavior: smooth ? "smooth" : "auto",
        block: "nearest",
        inline: "center",
      });
      return new Promise((resolve) => setTimeout(() => resolve(true), DELAY));
    },
  },

  computed: {
    computedID() {
      return this.id || "carousel-" + Math.floor(Math.random() * 5);
    },
  },

  mounted() {
    let slider = null;
    if (this.computedID) {
      slider = document.querySelector("#" + this.computedID);
    } else {
      slider = document.querySelector(".carousel");
    }

    let isDown = false;
    let startX;
    let scrollLeft;

    if (slider) {
      slider.addEventListener("mousedown", (e) => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
      });
      slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active");
      });
      slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 3; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
      });
    }
  },
};
</script>
